// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"576":"0e7a0353","840":"7f7053df"}[chunkId] + ".chunk.css";
};